import React from 'react';
import { Outlet } from 'react-router-dom';
const AppLayout = ({ page, data }) => {
    return (React.createElement("div", null,
        React.createElement(Outlet, null)));
};
export { AppLayout };
